var _rect, _g, _circle, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEndCallMobileIcon = function SvgEndCallMobileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#paint0_linear_1120_4482)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1120_4482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1345 32.0667C20.9972 31.204 22.521 30.3042 25.3494 29.5034C28.7935 28.5343 31.6426 27.9699 36.0263 27.9641C40.257 27.9628 42.6558 28.3022 46.7195 29.4835C51.3086 30.8164 52.5832 32.6461 52.9363 33.6197C53.3597 34.782 53.2885 35.8015 53.0543 36.9771C52.9162 37.6398 52.7174 38.2884 52.4603 38.9146C52.4351 38.9778 52.4121 39.037 52.3918 39.09C52.2716 39.4073 52.0891 39.8877 51.5101 40.1485C51.1248 40.3235 50.6594 40.3584 49.8811 40.3633C48.2862 40.3743 45.425 39.7079 44.154 39.2465C43.2984 38.9345 42.7332 38.729 42.3005 38.2972C41.7945 37.7912 41.6588 37.1464 41.5466 36.4163C41.5254 36.2793 41.5072 36.1463 41.4896 36.0172C41.3839 35.239 41.33 35.0374 41.0534 34.858C40.4965 34.4983 38.3973 33.8689 35.9843 33.8716C33.5713 33.8742 31.5578 34.5106 30.9996 34.8726C30.711 35.0595 30.6576 35.2668 30.5497 36.0711C30.5343 36.1865 30.5188 36.3054 30.5002 36.4273C30.3796 37.2489 30.2554 37.8689 29.7613 38.363L29.7587 38.3657C29.3286 38.7957 28.774 38.9773 27.8565 39.2796C26.6598 39.6738 23.7597 40.4075 22.159 40.4004C21.3808 40.3973 20.9154 40.3641 20.53 40.19C19.9498 39.928 19.7694 39.448 19.6461 39.1294C19.6258 39.0763 19.6037 39.018 19.5781 38.9544C19.3232 38.3275 19.1266 37.6785 18.9907 37.0156C18.7578 35.8431 18.6898 34.8231 19.1145 33.6586C19.3295 33.0575 19.6783 32.5132 20.1345 32.0667Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.0625
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.4
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 27.25,
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1120_4482",
    x1: 36,
    y1: 0,
    x2: 36,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3776AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1120_4482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(58.6274 36) rotate(135)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEndCallMobileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/end-call-mobile-icon.a82fb277.svg";
export { ForwardRef as ReactComponent };